import { render, staticRenderFns } from "./LlamadasPlaceHolder.vue?vue&type=template&id=6b264168&scoped=true&"
import script from "./LlamadasPlaceHolder.vue?vue&type=script&lang=js&"
export * from "./LlamadasPlaceHolder.vue?vue&type=script&lang=js&"
import style0 from "./LlamadasPlaceHolder.vue?vue&type=style&index=0&id=6b264168&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b264168",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCarousel } from 'vuetify/lib/components/VCarousel';
import { VCarouselItem } from 'vuetify/lib/components/VCarousel';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VApp,VCard,VCarousel,VCarouselItem,VCol,VContainer,VDivider,VIcon,VListItem,VListItemContent,VRow,VSimpleTable})
